import create from 'zustand';

import { Color } from '@styles/theme';

import { ReviewFindingTarget } from 'api/journey-reviews/requests';

type HighlightedFinding = {
  target: ReviewFindingTarget;
  color: Color;
};

type HighlightedFindingStore = {
  // The card the pointer is over, so the canvas can outline the node it names.
  highlighted: HighlightedFinding | null;
  highlightFinding: (target: ReviewFindingTarget, color: Color) => void;
  clearFinding: (target: ReviewFindingTarget) => void;
};

const isSameTarget = (one: ReviewFindingTarget, other: ReviewFindingTarget) =>
  one.kind === other.kind && (one.id ?? '') === (other.id ?? '');

export const useHighlightedFindingStore = create<HighlightedFindingStore>((set) => ({
  highlighted: null,
  highlightFinding: (target, color) => set({ highlighted: { target, color } }),
  // The next card's mouseenter fires before the previous card's mouseleave, so a
  // blind clear would wipe the highlight that just replaced this one.
  clearFinding: (target) =>
    set((state) =>
      state.highlighted && isSameTarget(state.highlighted.target, target)
        ? { highlighted: null }
        : state
    ),
}));
